const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3317";

export const DEFAULT_SETTINGS = {
  nom_club: "",
  shortname_club: "",
  responsable_club: "",
  logo_club: "",
  adresse_club: "",
  commune_club: "",
  tel_club: "",
  mail_club: "",
  siteweb_club: "",
  siret_club: "",
  facebook_club: "",
  instagram_club: "",
  primary_color: "#000000",
  about_title: "",
  about_content: "",
  carrousel_id: "",
  header1_photo_url: "",
  header2_photo_url: "",
  header_title: "",
  header_subtitle: "",
};

export const TABS = [
  {
    key: "identity",
    label: "Identité",
    helper: "Club, responsable, logo",
  },
  {
    key: "contact",
    label: "Coordonnées",
    helper: "Adresse, téléphone, réseaux",
  },
  {
    key: "home",
    label: "Accueil",
    helper: "Header, à propos, carrousel",
  },
];

export const safeJsonParse = (value, fallback = null) => {
  try {
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

export const isDemoUser = (user) => Number(user?.role_id) === 4;

export const isExternalURL = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const getMediaUrl = (url) => {
  if (!url) return "";
  if (isExternalURL(url)) return url;
  return `${BASE_URL}${url.startsWith("/") ? url : `/${url}`}`;
};

export const stripHtml = (html = "") =>
  String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const formatNumber = (value) =>
  new Intl.NumberFormat("fr-FR").format(Number(value || 0));

export const normalizeSettingsPayload = (settings) => ({
  ...settings,
  nom_club: String(settings.nom_club || "").trim(),
  shortname_club: String(settings.shortname_club || "").trim(),
  responsable_club: String(settings.responsable_club || "").trim(),
  logo_club: String(settings.logo_club || "").trim(),
  adresse_club: String(settings.adresse_club || "").trim(),
  commune_club: String(settings.commune_club || "").trim(),
  tel_club: String(settings.tel_club || "").trim(),
  mail_club: String(settings.mail_club || "").trim(),
  siteweb_club: String(settings.siteweb_club || "").trim(),
  siret_club: String(settings.siret_club || "").trim(),
  facebook_club: String(settings.facebook_club || "").trim(),
  instagram_club: String(settings.instagram_club || "").trim(),
  primary_color: String(settings.primary_color || "#000000").trim(),
  about_title: String(settings.about_title || "").trim(),
  about_content: String(settings.about_content || "").trim(),
  carrousel_id: settings.carrousel_id || "",
  header1_photo_url: String(settings.header1_photo_url || "").trim(),
  header2_photo_url: String(settings.header2_photo_url || "").trim(),
  header_title: String(settings.header_title || "").trim(),
  header_subtitle: String(settings.header_subtitle || "").trim(),
});

export const buildParametresStats = (settings = {}, galleries = []) => {
  const identityFields = [
    settings.nom_club,
    settings.shortname_club,
    settings.responsable_club,
    settings.siret_club,
    settings.logo_club,
  ];

  const contactFields = [
    settings.adresse_club,
    settings.commune_club,
    settings.tel_club,
    settings.mail_club,
    settings.siteweb_club,
    settings.facebook_club,
    settings.instagram_club,
  ];

  const homeFields = [
    settings.header1_photo_url,
    settings.header2_photo_url,
    stripHtml(settings.header_title),
    settings.header_subtitle,
    settings.about_title,
    stripHtml(settings.about_content),
    settings.carrousel_id,
  ];

  const countFilled = (fields) => fields.filter(Boolean).length;

  return {
    identityFilled: countFilled(identityFields),
    identityTotal: identityFields.length,
    contactFilled: countFilled(contactFields),
    contactTotal: contactFields.length,
    homeFilled: countFilled(homeFields),
    homeTotal: homeFields.length,
    galleriesCount: Array.isArray(galleries) ? galleries.length : 0,
    hasLogo: Boolean(settings.logo_club),
    hasPrimaryColor: Boolean(settings.primary_color),
  };
};

export const getCompletionPercent = (filled, total) => {
  if (!total) return 0;
  return Math.round((Number(filled || 0) / Number(total)) * 100);
};